import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import CloseIcon from '../UserPreferencesPanel/CloseIcon.js';
/**
 *
 * @example
 * <EnablePushNotificationsButton onClick={closeBanner} />
 */
export default function CloseBannerButton({ onClick }) {
    const handleClick = () => {
        onClick();
    };
    return (_jsx("button", { onClick: handleClick, "aria-label": "close notification", css: css `
        display: flex;
        align-items: center;

        svg {
          height: 24px;
        }
      `, children: _jsx(CloseIcon, {}) }));
}
//# sourceMappingURL=CloseBannerButton.js.map